/**
 * Privacy Policy — placeholder route (production-ready shell for legal counsel review).
 * Public. No auth required.
 */
import { useNavigate } from "react-router-dom";
import { Logo } from "@/components/Logo";
import { Shield } from "lucide-react";

export default function Privacy() {
  const navigate = useNavigate();
  return (
    <div className="min-h-screen grid-bg flex flex-col" data-testid="privacy-page">
      <header className="px-6 sm:px-8 py-6 flex items-center justify-between">
        <Logo size="md" />
        <button onClick={() => navigate("/")} data-testid="privacy-back-btn" className="text-slate-400 hover:text-white text-sm">← Back</button>
      </header>
      <main className="flex-1 max-w-3xl w-full mx-auto px-6 sm:px-8 pb-24">
        <div className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full border border-emerald-500/30 bg-emerald-500/10 text-emerald-300 text-xs font-semibold uppercase tracking-widest mb-6">
          <Shield size={12} /> Compliance
        </div>
        <h1 className="text-4xl sm:text-5xl font-bold tracking-tighter text-white leading-tight">Privacy Policy</h1>
        <p className="text-slate-400 mt-4 text-sm">Last updated · February 2026</p>

        <section className="mt-10 space-y-8 text-slate-300 text-[15px] leading-relaxed">
          <div>
            <h2 className="text-white text-lg font-semibold mb-2">1. Data we collect</h2>
            <p>Receipt Sheets processes receipt images, extracted metadata (merchant, date, totals, line items), your email + name (via Google), and payment metadata from Stripe. We do not store raw payment card numbers.</p>
          </div>
          <div>
            <h2 className="text-white text-lg font-semibold mb-2">2. How we use your data</h2>
            <p>Data is used solely to deliver the service: OCR extraction, categorization, tax reporting, and CPA hand-off (when initiated by you). We do not sell or share personal data with third parties for advertising.</p>
          </div>
          <div>
            <h2 className="text-white text-lg font-semibold mb-2">3. Encryption & retention</h2>
            <p>All data is encrypted in transit (TLS 1.2+) and at rest (AES-256). Receipts are retained for 7 years to meet IRS audit requirements. Delete-on-request is honored within 30 days.</p>
          </div>
          <div>
            <h2 className="text-white text-lg font-semibold mb-2">4. Contact</h2>
            <p className="font-mono text-sm text-emerald-300">privacy@receiptsheets.com</p>
          </div>
          <p className="text-slate-500 text-xs italic border-t border-white/5 pt-6">
            This is a placeholder legal document. Full policy is under counsel review; production version replaces this shell prior to public sign-ups.
          </p>
        </section>
      </main>
    </div>
  );
}
